import { ReadObject, SaveObject } from './storage'

export const DEVELOPMENT_MODE = true 
export const AKAMAI_ENDPOINT = 'https://joinkidsv02.akamaized.net/'
// 🧪 28/09/2026: REACT_APP_API_ENDPOINT existe SÓ para testar a tela num servidor de mentira
// no computador (o teste nunca pode cobrar nem gravar no banco de verdade). Sem ele, que é
// como a publicação roda, o endereço é o de produção de sempre.
export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'https://api.joinkids.com.br/api'
export const GetHeaders = async authenticated => {
	const headers = { 'Content-Type': 'application/json' }
	const authentication = await ReadObject('authentication')
	if (authenticated && authentication.jwt) {
		headers.Authorization = `Bearer ${authentication.jwt}`
	}
	return { headers }
}

// Evita disparar vários redirecionamentos de uma vez quando várias requisições
// falham juntas por causa da mesma sessão expirada.
let sessionExpiredHandled = false

// Chamado quando o servidor recusa uma requisição que exige login (a "pulseira"/token
// venceu ou ficou inválida). Limpa a sessão e leva o usuário para o login com um aviso.
const handleSessionExpired = () => {
	SaveObject('authentication', {})
	try { sessionStorage.setItem('JoinKids::sessionExpired', '1') } catch (e) { /* ignora */ }

	const path = (typeof window !== 'undefined' && window.location?.pathname) || ''
	const isPublicPage = path === '/'
		|| path.startsWith('/login')
		|| path.startsWith('/register')
		|| path.startsWith('/forgot')
		|| path.startsWith('/planos')
		|| path.startsWith('/privacity')

	// Só redireciona se a pessoa está numa área logada (evita ficar em loop na própria tela de login).
	if (!isPublicPage && !sessionExpiredHandled) {
		sessionExpiredHandled = true
		window.location.href = '/login'
	}
}

export const ServerFetch = async (url, options, authenticated) => {
	const { headers } = await GetHeaders(authenticated)
	// console.info(url, options, headers)
	try{
		const response = await fetch(url, { ...options, headers })
		// Sessão expirada/inválida: o servidor responde 401 (não autenticado) ou 403 (sem permissão)
		// para requisições que exigem login. Antes, aqui checava "statusCode" (nome errado) e só 403,
		// por isso nunca funcionava — e o usuário caía na tela de assinatura sem nenhum aviso.
		if (authenticated && (response.status === 401 || response.status === 403)) {
			handleSessionExpired()
		}
		try{
			return await response.json()
		}catch(err){
			console.log('ServerParseError', err)
			return response
		}
	}catch(error){
		console.log('ServerFetchError', error)
		return false;
	}
}

export const GET = async (path, authenticated = false) => {
	return await ServerFetch(
		`${API_ENDPOINT}${path}`,
		{
			method: 'GET'
		},
		authenticated
	)
}

export const POST = async (path, body, authenticated = false) => {
	return await ServerFetch(
		`${API_ENDPOINT}${path}`,
		{
			method: 'POST',
			body: JSON.stringify(body)
		},
		authenticated
	)
}

export const PUT = async (path, body, authenticated = false) => {
	return await ServerFetch(
		`${API_ENDPOINT}${path}`,
		{
			method: 'PUT',
			body: JSON.stringify(body)
		},
		authenticated
	)
}

export const DELETE = async (path, authenticated = false) => {
	return await ServerFetch(
		`${API_ENDPOINT}${path}`,
		{
			method: 'DELETE'
		},
		authenticated
	)
} 

export const ReadAddressesByZipCode = async (zipCode) => {
    try{
        let result = await fetch(`https://viacep.com.br/ws/${ zipCode }/json/`);
        return result.json();
    }catch(err){ return false; }
}



export const PostImage = async (fileToUpload) => {
    const formData = new FormData()
    formData.append('file', fileToUpload, fileToUpload.name)  
    let { headers } = await GetHeaders(true) 
    delete headers['Content-Type']
    let response = await fetch(`${API_ENDPOINT}/upload`, { method: 'POST', body: formData, headers });   
    let responseJson = await response.json()  
    return responseJson; 
}
  
export const PrepareImageFile = (image) => {
	let btc = window.atob(image.source)
	let btn = new Array(btc.length);
	for (var i = 0; i < btc.length; i++) {
		btn[i] = btc.charCodeAt(i);
	}
	var bta = new Uint8Array(btn);
	let boobs = new Blob([bta], {type: 'image/png' } );
	return new File([boobs], `${ image.filename }`)
} 

export const UploadImage = (file) => {
	return new Promise((resolve, reject) => { 
		let reader = new FileReader();
		reader.onload = async () => {
			let source = `${ reader.result }`.split(',')[1]
			let image = {
				filename: file.name,
				filetype: file.type,
				source
			}
			let thefile = PrepareImageFile(image);
			let result = await PostImage(thefile);

			resolve(result);
		};
		reader.readAsDataURL(file);
	})
} 
 
export const parseStrapiImage = url => {
    return !url ? '' : url.indexOf('://') !== -1 ? url : `${API_ENDPOINT.replace('/api', '')}${url}`
}